<template>
  <div class="card">
    <div class="card-header pb-0">
      <div class="float-start">
        <h6>Industry table</h6>
      </div>
      <div class="float-end">
        <div class="row">
          <!-- <div class="col-4">
            <select name="pagesx" id="pagesx" v-model="pages" @change="changepages" class="form-select form-select-sm">
              <option value="advisory">Advisory</option>
              <option value="bom">BOM</option>
              <option value="advisory_main">Advisory Main</option>
              <option value="bom_main">BOM Main</option>
            </select>
          </div> -->
          
          <div class="col-6">
            <div class="input-group mb-3">
              <input type="search" class="form-control form-control-sm" placeholder="Cari title disini..." id="cari" name="cari" v-model="searchQuery" aria-label="Recipient's username" aria-describedby="cari">
              <button class="btn btn-outline-secondary btn-sm" style="margin-bottom: 0%;" type="button" id="cari" @click="cari"><i class="fas fa-search"></i></button>
            </div>
          </div>
          <div class="col-6">
            <!-- Button to open the modal -->
            <button class="btn btn-sm btn-dark me-2" @click="showModal = true">
              <i class="fa fa-plus"></i> Add Industry
            </button>
          </div>
          
        </div>
      </div>
    </div>
    <div class="card-body px-0 pt-0 pb-2">
      <argon-alert v-if="alertstatus != null" :color="alertstatus">
        <strong>{{alertstatus}}</strong> {{alerttext}}
      </argon-alert>
      <div class="table-responsive p-0">
        <table class="table align-items-center mb-0">
          <thead>
            <tr>
              <th
                class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
              >
                Title
              </th>
              <th
                class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
              >
                Cover
              </th>
              <th
                class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
              >
                Detail
              </th>
              <th
                class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
              >
                Action
              </th>
              
            </tr>
          </thead>
          <tbody>
            <!-- Loop through banner_list and populate rows -->
            <tr v-for="(item, index) in paginatedData" :key="index">
              <td>{{ item.title }}</td>
              <td><img :src="item.cover" alt="cover" style="width: 100px; height: auto;"></td>
              <td>
                <div class="row  text-center">
                  <div class="col-sm-12" v-for="(detail, idx) in item.industry_detail_data" :key="idx">
                    <div class="card">
                      <div class="card-body">
                        <img :src="detail?.file " alt="cover" class="img-fluid" style="width: 100px; height: auto;" v-if="detail.file">
                        <div class="container" v-if="item?.option_content_page == '1' || item?.option_content_page == '2' ">
                            <div v-html="truncateHTML(detail?.description, 50)"></div>
                        </div>
                        <div class="container" v-if="item?.option_content_page == '3' ">
                            <div v-html="truncateHTML(detail?.content, 50)"></div>
                        </div>
                        <div class="container" v-if="item?.option_content_page == '4' ">
                            <div v-html="truncateHTML(detail?.content, 50)"></div>
                            <h6>Location : {{ detail?.location }}</h6>
                            <h6>Industry : {{ detail?.industry }}</h6>
                            <h6>Use case : {{ detail?.use_case }}</h6>
                            <h6>Size of company : {{ detail?.size_of_company }}</h6>
                            <h6>Number of happy : {{ detail?.number_of_happy }}</h6>
                        </div>
                      </div>
                      <div class="card-footer" style="padding: 0%;">
                        <button type="button" class="btn btn-sm btn-primary" @click="editdetail(detail, item?.option_content_page)"><i class="fa fa-edit"></i></button>
                      </div>
                    </div>
                  </div>
                </div>
              </td>
              <td class="text-center">
                <!-- Action buttons (like edit/delete) can go here -->
                <button type="button" class="btn btn-sm btn-primary me-2" @click="edit(item)"><i class="fa fa-edit"></i></button>
                <button type="button" class="btn btn-sm btn-danger" @click="hapus(item?.id)"><i class="fa fa-trash"></i></button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="d-flex justify-content-center">
        <argon-pagination>
          <!-- Previous Page Button -->
          <argon-pagination-item 
            prev  
            :disabled="currentPage === 1" 
            @click="prevPage"
          />
          
          <!-- Page Numbers -->
          <argon-pagination-item 
            v-for="page in totalPages" 
            :key="page" 
            :label="String(page)" 
            :active="currentPage === page" 
            @click="setPage(page)"
          />
          
          <!-- Next Page Button -->
          <argon-pagination-item 
            next  
            :disabled="currentPage === totalPages" 
            @click="nextPage"
          />
        </argon-pagination>
      </div>
      
      <div :class="showModal == true ? 'modal-backdrop': '' "></div>
      <div class="modal fade" :class="showModal == true ? 'show': '' " tabindex="-1" aria-labelledby="modalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered custom-width-modal">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="modalLabel" v-if="method == 'add' ">Add New Industry</h5>
              <h5 class="modal-title" id="modalLabel" v-else>Edit Industry</h5>
              <button type="button" class="btn btn-secondary btn-sm" @click="closeModal">X</button>
            </div>
            <div class="modal-body">
              <form @submit.prevent="submitForm">
                <div class="mb-3" v-if="method != 'editdetail'">
                  <label for="title" class="form-label">Title</label>
                  <input type="text" class="form-control" v-model="formData.title" id="title" required>
                </div>
                <div class="mb-3" v-if="method != 'editdetail'">
                  <label for="cover" class="form-label">Cover</label>
                  <input type="file" class="form-control" @change="handleFileUploadCover" :required="method === 'add'" accept="image/*">
                  <div v-if="imgreview" class="m-4">
                    <img :src="imgreview" alt="" srcset="" style="max-height: 100px;">
                  </div>
                </div>

                <div class="mb-3" v-if="method === 'add'">
                  <label for="option_content" class="form-label">Option Content</label>
                  <select name="option_content" id="option_content" v-model="formData.optioncontent" class="form-select">
                    <option value="1">Option 1</option>
                    <option value="2">Option 2</option>
                    <option value="3">Option 3</option>
                    <option value="4">Option 4</option>
                  </select>
                </div>
                <div class="mb-3" v-if="method != 'editdetail'">
                  <label for="option_content" class="form-label">Pilih Icon</label>
                  <div class="icon-radio-group">
                    <label
                      v-for="(icon, idx) in iconList"
                      :key="idx"
                      class="icon-radio"
                    >
                      <input
                        type="radio"
                        :value="icon.icon"
                        v-model="formData.icon"
                      />
                      <img
                        :src="icon.icon"
                        :alt="icon.name"
                        class="icon-image"
                      />
                      <span>{{ icon.name }}</span>
                    </label>
                  </div>
              
                  <!-- Pratinjau Ikon yang Dipilih -->
                  <div class="mt-2">
                    <p>Ikon Terpilih:</p>
                    <img
                      :src="formData.icon"
                      alt="Selected Icon"
                      v-if="formData.icon"
                      style="width: 40px; height: 40px;"
                    />
                  </div>
                </div>
              
              
                <div class="mb-3" v-if="method != 'editdetail'">
                  <label for="option_content" class="form-label">Deskripsi</label>
                  <QuillEditor 
                        theme="snow" 
                        v-model:content="formData.desciptioncontent"
                        contentType="html" 
                        class="large-editor"
                        />
                  <small class="text-danger">*Tambahkan https:// jika itu link</small>
                </div>
                <hr>
                               
                
                  <div v-if="method ==  'add'">
                    <div v-if="formData.optioncontent == '1' || formData.optioncontent == '2' ">
                      <div v-for="(item, index) in jmldetail" :key="index">
                        <div class="mb-3" v-if="method == 'add' ">
                          <label for="deskripsi" class="form-label">Deskripsi {{ index +1 }}</label>
                          <QuillEditor 
                          theme="snow" 
                          v-model:content="formData.desciption[index]"
                          contentType="html" 
                          class="large-editor"
                          />
                          <small class="text-danger">*Tambahkan https:// jika itu link</small>
                        </div>
                        <div class="mb-3" v-if="method == 'add' || method == 'editdetail' ">
                          <label for="file" class="form-label">File {{ index +1 }}</label>
                          <input type="file" class="form-control" @change="handleFileUpload($event, index)" :required="method === 'add'" accept="image/*" v-if="method == 'add' ">
                          <input type="file" class="form-control" @change="handleFileUploaddetail" :required="method === 'add'" accept="image/*"  v-if="method == 'editdetail' ">
                          <small class="text-danger">*Max resolusi 1080x607 (Rekomendasi)</small>
                        </div>
                        <div class="mb-3" v-if="method == 'editdetail' ">
                          <label for="deskripsi" class="form-label">Deskripsi</label>
                          <QuillEditor 
                          theme="snow" 
                          v-model:content="formData.desciption"
                          contentType="html" 
                          class="large-editor"
                          />
                          <small class="text-danger">*Tambahkan https:// jika itu link</small>
                        </div>
                        <!-- Remove Button -->
                        <div class="text-end" v-if="index >= 1">
                          <button type="button" class="btn btn-sm btn-danger" @click="removeDetail(index)">
                            <i class="fas fa-minus"></i> Remove
                          </button>
                        </div>
                      </div>
                      <!-- Add Button -->
                      <div v-if="method == 'add' ">
                        <button type="button" class="btn btn-sm btn-success" @click="addDetail">
                          <i class="fas fa-plus"></i> Add
                        </button>
                      </div>
  
                    </div>
                    <div v-else-if="formData.optioncontent == '3'">
                      <div class="mb-3">
                        <label for="deskripsicontent" class="form-label">Deskripsi Content</label>
                        <QuillEditor 
                        theme="snow" 
                        v-model:content="formData.content"
                        contentType="html" 
                        class="large-editor"
                        id="deskripsicontent"
                        />
                        <small class="text-danger">*Tambahkan https:// jika itu link</small>
                      </div>
                    </div>
                    <div v-else-if="formData.optioncontent == '4'">
                      <div class="mb-3">
                        <label for="deskripsicontent4" class="form-label">Deskripsi Content</label>
                        <QuillEditor 
                        theme="snow" 
                        v-model:content="formData.content"
                        contentType="html" 
                        class="large-editor"
                        id="deskripsicontent4"
                        />
                        <small class="text-danger">*Tambahkan https:// jika itu link</small>
                      </div>
                      <div class="mb-3">
                        <label for="logo" class="form-label">Logo</label>
                        <input type="file" class="form-control" @change="handleFileUploadlogo" :required="method === 'add'" accept="image/*">
                      </div>
                      <div class="mb-3">
                        <label for="location">Location</label>
                        <input type="text" class="form-control" v-model="formData.location" id="location" required>
                      </div>
                      <div class="mb-3">
                        <label for="industry">Industry</label>
                        <input type="text" class="form-control" v-model="formData.industry" id="industry" required>
                      </div>
                      <div class="mb-3">
                        <label for="use_case">Use case</label>
                        <input type="text" class="form-control" v-model="formData.use_case" id="use_case" required>
                      </div>
                      <div class="mb-3">
                        <label for="size_of_company">Size of company</label>
                        <input type="text" class="form-control" v-model="formData.size_of_company" id="size_of_company" required @keypress="validateInput($event)">
                      </div>
                      <div class="mb-3">
                        <label for="number_of_happy">Number of happy</label>
                        <input type="text" class="form-control" v-model="formData.number_of_happy" id="number_of_happy" required @keypress="validateInput($event)">
                      </div>
                      <hr>
                      <div v-for="(item, index) in jmldetailicon" :key="index">
                        <div class="mb-3" v-if="method == 'add' ">
                          <label for="title" class="form-label">Title {{ index +1 }}</label>
                          <input type="text" class="form-control" v-model="formData.journeytitle[index]"  required >
                        </div>
                        <div class="mb-3" v-if="method == 'add' ">
                          <label for="number" class="form-label">Number {{ index +1 }}</label>
                          <input type="text" class="form-control" v-model="formData.journeynumber[index]"  required @keypress="validateInput($event)">
                        </div>
                        <div class="mb-3" v-if="method == 'add' ">
                          <label for="icon" class="form-label">Icon {{ index +1 }}</label>
                          <label for="option_content" class="form-label">Pilih Icon</label>
                          <div class="icon-radio-group">
                            <label
                              v-for="(icon, idx) in iconList"
                              :key="idx"
                              class="icon-radio"
                            >
                              <input
                                type="radio"
                                :value="icon.icon"
                                v-model="formData.journeyicon[index]"
                                required
                              />
                              <img
                                :src="icon.icon"
                                :alt="icon.name"
                                class="icon-image"
                              />
                              <span>{{ icon.name }}</span>
                            </label>
                          </div>
                      
                          <!-- Pratinjau Ikon yang Dipilih -->
                          <div class="mt-2">
                            <p>Ikon Terpilih:</p>
                            <img
                              :src="formData.journeyicon[index]"
                              alt="Selected Icon"
                              v-if="formData.journeyicon[index]"
                              style="width: 40px; height: 40px;"
                            />
                          </div>
                        </div>
                        <!-- Remove Button -->
                        <div class="text-end" v-if="index >= 1">
                          <button type="button" class="btn btn-sm btn-danger" @click="removeDetailicon(index)">
                            <i class="fas fa-minus"></i> Remove
                          </button>
                        </div>
                      </div>
                        <!-- Add Button -->
                      <div v-if="jmldetailicon.length < 4 ">
                        <button type="button" class="btn btn-sm btn-success" @click="addDetailicon">
                          <i class="fas fa-plus"></i> Add
                        </button>
                      </div>

                      <div v-for="(item, index) in bannerslider" :key="index">
                        <div class="mb-3">
                          <label for="title" class="form-label">Title Banner {{ index +1 }}</label>
                          <input type="text" class="form-control" v-model="formData.banner_title[index]" required>
                        </div>
                        <div class="mb-3">
                          <label for="img" class="form-label">FIle Banner</label>
                          <input type="file" id="img" class="form-control" @change="handleFileUploadbanner($event, index)" :required="method === 'add'" accept="image/*" v-if="method != 'edit' ">
                        </div>
                        <!-- Remove Button -->
                        <div class="text-end" v-if="index >= 1">
                          <button type="button" class="btn btn-sm btn-danger" @click="removebanner(index)">
                            <i class="fas fa-minus"></i> Remove Banner
                          </button>
                        </div>
                      </div>
                      <div v-if="method == 'add' ">
                        <button type="button" class="btn btn-sm btn-success" @click="addbanner">
                          <i class="fas fa-plus"></i> Add Banner
                        </button>
                      </div>
                    </div>
                    
                  </div>
                  
                  
                  <div v-else>
                    <div v-if="optionselect == 1 || optionselect == 2">
                      <div class="mb-3" v-if="method == 'editdetail' ">
                        <label for="deskripsi" class="form-label">Deskripsi</label>
                        <QuillEditor
                            theme="snow" 
                            v-model:content="formData.desciption"
                            contentType="html"
                            class="large-editor"
                          />
                        <small class="text-danger">*Tambahkan https:// jika itu link</small>
                      </div>
                      <div class="mb-3" v-if="method == 'add' || method == 'editdetail' ">
                        <label for="file" class="form-label">File</label>
                        <input type="file" class="form-control" @change="handleFileUpload($event, index)" :required="method === 'add'" accept="image/*" v-if="method == 'add' ">
                        <input type="file" class="form-control" @change="handleFileUploaddetail" accept="image/*"  v-if="method == 'editdetail' ">
                        <div v-if="imgreview" class="m-4">
                          <img :src="imgreview" alt="" srcset="" style="max-height: 100px;">
                        </div>
                      </div>
                    </div>
                    <div v-if="optionselect == 4">
                      <div class="mb-3" v-if="method == 'editdetail' ">
                        <label for="deskripsi" class="form-label">Deskripsi</label>
                        <QuillEditor
                            theme="snow" 
                            v-model:content="formData.content"
                            contentType="html"
                            class="large-editor"
                          />
                        <small class="text-danger">*Tambahkan https:// jika itu link</small>
                      </div>
                      <div class="mb-3">
                        <label for="logo" class="form-label">Logo</label>
                        <input type="file" class="form-control" @change="handleFileUploadlogo" :required="method === 'add'" accept="image/*">
                      </div>
                      <div class="mb-3">
                        <label for="location">Location</label>
                        <input type="text" class="form-control" v-model="formData.location" id="location" required>
                      </div>
                      <div class="mb-3">
                        <label for="industry">Industry</label>
                        <input type="text" class="form-control" v-model="formData.industry" id="industry" required>
                      </div>
                      <div class="mb-3">
                        <label for="use_case">Use case</label>
                        <input type="text" class="form-control" v-model="formData.use_case" id="use_case" required>
                      </div>
                      <div class="mb-3">
                        <label for="size_of_company">Size of company</label>
                        <input type="text" class="form-control" v-model="formData.size_of_company" id="size_of_company" required @keypress="validateInput($event)">
                      </div>
                      <div class="mb-3">
                        <label for="number_of_happy">Number of happy</label>
                        <input type="text" class="form-control" v-model="formData.number_of_happy" id="number_of_happy" required @keypress="validateInput($event)">
                      </div>

                      <div v-for="(item, index) in journeyData" :key="index">
                        <div class="mb-3">
                          <label for="title" class="form-label">Title {{ index +1 }}</label>
                          <input type="text" class="form-control" v-model="item.title" required>
                        </div>
                        <div class="mb-3">
                          <label for="number" class="form-label">Number {{ index +1 }}</label>
                          <input type="text" class="form-control" v-model="item.number" required @keypress="validateInput($event)">
                        </div>
                        <div class="mb-3">
                          <label for="icon" class="form-label">Icon {{ index +1 }}</label>
                          <input type="text" class="form-control" v-model="item.icon" required readonly>
                          <label for="option_content" class="form-label">Pilih Icon</label>
                          <div class="icon-radio-group">
                            <label v-for="(icon, idx) in iconList" :key="idx" class="icon-radio">
                              <input type="radio" :value="icon.icon" v-model="item.icon" />
                              <img :src="icon.icon" :alt="icon.name" class="icon-image" />
                              <span>{{ icon.name }}</span>
                            </label>
                          </div>
                          <div class="mt-2">
                            <p>Ikon Terpilih:</p>
                            <img :src="item.icon" alt="Selected Icon" v-if="item.icon" style="width: 40px; height: 40px;" />
                          </div>
                        </div>
  
                        <div class="row">
                          <!-- Remove Button -->
                          <div class="col-sm text-end">
                            <button type="button" class="btn btn-sm btn-danger" @click="removeDetailIcon(item.id, index)">
                              <i class="fas fa-minus"></i> Remove
                            </button>
                          </div>
                          <div class="col-sm text-start">
                            <button
                              type="button"
                              class="btn btn-sm btn-info"
                              @click="updateDetailIcon(item.id, index)"
                            >
                              <i class="fas fa-pen"></i> Update
                            </button>
                          </div>
                          <!-- Save Icon Button (Only for New Data) -->
                          <div class="col-sm text-center" v-if="index >= jmljourneyDataold">
                            <button
                              type="button"
                              class="btn btn-primary btn-sm"
                              @click="addicon(item)"
                            >
                              <i class="fas fa-save"></i> Save Icon
                            </button>
                          </div>
                        </div>
                        
                      </div>
                      
                      <!-- Add Button -->
                      <div v-if="journeyData.length < 4">
                        <button type="button" class="btn btn-sm btn-success" @click="addDetailiconEdit">
                          <i class="fas fa-plus"></i> Add
                        </button>
                      </div>
  
                      <div v-for="(item, index) in bannerslider" :key="index">
                        <div class="mb-3">
                          <label for="title" class="form-label">Title Banner {{ index +1 }}</label>
                          <input type="text" class="form-control" v-model="formData.banner_title[index]" required>
                        </div>
                        <div class="mb-3">
                          <label for="img" class="form-label">File Banner</label>
                          <input type="file" id="img" class="form-control" @change="handleFileUploadbanner($event, index)" :required="method === 'add'" accept="image/*" v-if="method != 'edit' ">
                        </div>
                        <!-- Remove Button -->
                        <div class="text-end" v-if="index >= 1">
                          <button type="button" class="btn btn-sm btn-danger" @click="removebanner(index)">
                            <i class="fas fa-minus"></i> Remove Banner
                          </button>
                        </div>
                      </div>
                      <div v-if="method == 'editdetail' ">
                        <button type="button" class="btn btn-sm btn-success" @click="addbanner">
                          <i class="fas fa-plus"></i> Add Banner
                        </button>
                      </div>
                    </div>                  
                  </div>
                
                
                
                <div class="text-end">
                  <button type="button" class="btn btn-secondary btn-sm me-2" @click="closeModal">Close</button>
                  <button type="submit" class="btn btn-primary btn-sm">Submit</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>


    </div>
  </div>
  
</template>
<script>
import axios from "axios";
import ArgonPagination from "@/components/ArgonPagination.vue";
import ArgonPaginationItem from "@/components/ArgonPaginationItem.vue";
import ArgonAlert from "@/components/ArgonAlert.vue";

import { QuillEditor } from '@vueup/vue-quill'
import '@vueup/vue-quill/dist/vue-quill.snow.css';
import ImageUploader from "quill-image-uploader";
export default {
  data() {
    return {
      industryList: [], // Holds the list of banners
      currentPage: 1, // Track the current page
      totalPages: [], // Total number of pages
      itemsPerPage:10,
      sortOrder: 'desc',
      searchQuery: '',
      pages: 'advisory',
      showModal: false, // Controls modal visibility
      formData: {
        pages: 'advisory',
        title: '',
        cover: null,
        files: [],
        banner: [],
        banner_title: [],
        desciption: [],
        optioncontent: 1,
        icon: '',
        desciptioncontent:'',
        journeyicon: [],
        journeytitle: [],
        journeynumber: [],
      },
      method: 'add',
      alertstatus: null,
      alerttext: null,
      jmldetail: [{}],
      jmldetailicon: [{}],
      journeyData: [], // Pisahkan journey
      journeyDataold: [],
      jmljourneyDataold: '',
      bannerslider: [{}],
      optionselect: '',
      iconList: [
        { name: "Icon 1", icon: "/icons/01.png" },
        { name: "Icon 2", icon: "/icons/02.png" },
        { name: "Icon 3", icon: "/icons/03.png" },
        { name: "Icon 4", icon: "/icons/04.png" },
        { name: "Icon 5", icon: "/icons/05.png" },
        { name: "Icon 6", icon: "/icons/06.png" },
        { name: "Icon 7", icon: "/icons/07.png" },
        { name: "Icon 8", icon: "/icons/08.png" },
        { name: "Icon 9", icon: "/icons/09.png" },
        { name: "Icon 10", icon: "/icons/10.png" },
        { name: "Icon 11", icon: "/icons/11.png" },
        { name: "Icon 12", icon: "/icons/12.png" },
        { name: "Icon 13", icon: "/icons/13.png" },
        { name: "Icon 14", icon: "/icons/14.png" },
        { name: "Icon 15", icon: "/icons/15.png" },
        { name: "Icon 16", icon: "/icons/16.png" },
        { name: "Icon 17", icon: "/icons/17.png" },
        { name: "Icon 18", icon: "/icons/18.png" },
        { name: "Icon 19", icon: "/icons/19.png" },
        { name: "Icon 20", icon: "/icons/20.png" },
        { name: "Icon 21", icon: "/icons/21.png" },
        { name: "Icon 22", icon: "/icons/22.png" },
        { name: "Icon 23", icon: "/icons/23.png" },
        { name: "Icon 24", icon: "/icons/24.png" },
        { name: "Icon 25", icon: "/icons/25.png" },
      ],
      imgreview: null,
    };
  },
  components: {
   ArgonPagination,
   ArgonPaginationItem,
   ArgonAlert,
   QuillEditor
   },
  mounted() {
    // Fetch the banner list when the component is mounted
    this.fetchindustryList();
  },
  computed: {
    totalItems() {
      return this.industryList.length;
    },
    paginatedData() {
      return this.industryList.slice(0, this.itemsPerPage);
    },
    currentContent() {
      return this.formData?.desciption || this.formData?.content || '';
    },
  },
  setup: () => {
    const modules = {
      name: 'imageUploader',
        module: ImageUploader,
        options: {
          upload: file => {
            return new Promise((resolve, reject) => {
              let access_token = localStorage.getItem('access_token');
              const formData = new FormData();
              formData.append("attachment", file);
              console.log(file);

              axios.post('https://api-profile.productscala.online/admin/upload/editor/usecase', formData, {
                headers: {
                  'Authorization': 'Bearer ' + access_token, // Replace with the actual token
                  'Content-Type': 'multipart/form-data'
                }
              })
              .then(res => {
                console.log(res);
                resolve(res.data.data?.attachment);
              })
              .catch(err => {
                reject("Upload failed");
                console.error("Error:", err);
              });

            })
          }
      }
    };
    return { modules }
  },
 
  methods: {
    async fetchindustryList() {
      let access_token = localStorage.getItem('access_token');
      const config = {
        method: "get",
        url: "https://api-profile.productscala.online/admin/industry",
        params: {
          sort: this.sortOrder,
          limit: this.itemsPerPage,
          paginate: this.currentPage,
          key_search: this.searchQuery,
          pages: this.pages
        },
        headers: {
          'Authorization': 'Bearer '+ access_token // Replace with the actual token
        },
      };

      await axios
        .request(config)
        .then((response) => {   
          if (response.data?.message == 'success') {
            this.industryList = response.data.data.industry_list; // Assign banner_list to local data
            this.totalPages = response.data.data.paginate // Update the total number of pages (this depends on how the API returns pagination info)
          }else{
            this.alertstatus = 'danger';
            this.alerttext = 'Error get data'
          }
        })
        .catch((error) => {
          var err = error.response.data.message
          this.alertstatus = 'danger';
          this.alerttext = err
          console.error("Error fetching data:", error);
        });
    },
    nextPage() {
      if (this.currentPage < this.totalPages.length) {
        this.currentPage++;
        this.fetchindustryList();
      }
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.fetchindustryList();
      }
    },
    setPage(page) {
      this.currentPage = page;
      this.fetchindustryList();
    },
    updateItemsPerPage() {
      this.fetchindustryList();
    },
    updatesoftby(){
      this.fetchindustryList();
    },
    changepages(){
      console.log(this.pages);
      this.fetchindustryList();
    },
    cari(){
      this.fetchindustryList();
    },
    truncateText(text, length) {
      if (text.length > length) {
        return text.slice(0, length) + '...';
      }
      return text;
    },
    truncateHTML(htmlContent, maxLength) {
      const tempElement = document.createElement('div');
      tempElement.innerHTML = htmlContent || '';
      const textContent = tempElement.textContent || tempElement.innerText || '';

      // Potong teks jika panjangnya melebihi maxLength
      if (textContent.length > maxLength) {
        return textContent.slice(0, maxLength) + '...';
      }

      return htmlContent;
    },
    handlePages(){
      if (this.formData.pages == 'bom') {
        this.jmldetail = 3;
      }else{
        this.jmldetail = 2;
      }
    },
    closeModal() {
      this.showModal = false;
      // Reset form data
      this.formData= {
        pages: 'advisory',
        title: '',
        cover: null,
        files: [],
        banner: [],
        banner_title: [],
        desciption: [],
        optioncontent: 1,
        icon: '',
        desciptioncontent:'',
        journeyicon: [],
        journeytitle: [],
        journeynumber: [],
      },
      this.imgreview = null;
      this.method = 'add';
    },
    handleFileUpload(event, index) {
      const file = event.target.files[0];
      // Make sure the array has the correct length
      if (this.formData.files.length <= index) {
        this.formData.files.splice(index, 0, file);
      } else {
        this.formData.files[index] = file;
      }
      console.log(this.formData.files);
      
    },
    handleFileUploadbanner(event, index) {
      const file = event.target.files[0];
      // Make sure the array has the correct length
      if (this.formData.banner.length <= index) {
        this.formData.banner.splice(index, 0, file);
      } else {
        this.formData.banner[index] = file;
      }
    },
    handleFileUploadCover(event) {
      this.formData.cover = event.target.files[0]; // Capture the single cover file
      this.imgreview = URL.createObjectURL(event.target.files[0]); // Buat URL untuk preview gambar
    },
    handleFileUploadlogo(event) {
      this.formData.logo = event.target.files[0]; // Capture the single cover file
    },
    handleFileUploaddetail(event) {
      this.formData.files = event.target.files[0]; // Capture the single cover file
      this.imgreview = URL.createObjectURL(event.target.files[0]); // Buat URL untuk preview gambar
    },
    addDetail() {
      this.jmldetail.push({ desciption: '', file: null });
      this.formData.desciption.push(''); // Add an empty description for binding
    },
    removeDetail(index) {
      this.jmldetail.splice(index, 1);
      this.formData.desciption.splice(index, 1); // Remove corresponding description
    },
    addDetailicon() {
    this.jmldetailicon.push({ journeytitle: '', journeynumber: '', journeyicon: '' });
    },
    removeDetailicon(index) {
      this.jmldetailicon.splice(index, 1);
    },
    addbanner() {
      this.bannerslider.push({ banner_title: '', banner: null });
    },
    removebanner(index) {
      this.bannerslider.splice(index, 1);
    },

    async submitForm() {
      let access_token = localStorage.getItem('access_token');
      const data = new FormData();
      var config = {}
      if (this.method == 'add') {
        data.append('pages', this.formData.pages);
        data.append('title', this.formData.title);
        data.append('icon', this.formData.icon);
        data.append('description_content_pages', this.formData.desciptioncontent);
        if (this.formData.cover) {
          data.append('cover', this.formData.cover);
        }
        data.append('option_content_page', this.formData.optioncontent);
        
        if (this.formData.optioncontent == '1' || this.formData.optioncontent == '2') {
          // Tambahkan deskripsi
          this.formData.desciption.forEach((desc, index) => {
            data.append(`description[${index}]`, desc);
          });
          // Append files to FormData
          this.formData.files.forEach((file) => {
            data.append('file', file);
          });  
        }else if (this.formData.optioncontent == '3') {
          data.append('content', this.formData.content);
        }else if (this.formData.optioncontent == '4'){
          data.append('content', this.formData.content);
          data.append('logo', this.formData.logo);
          data.append('location', this.formData.location);
          data.append('industry', this.formData.industry);
          data.append('use_case', this.formData.use_case);
          data.append('size_of_company', this.formData.size_of_company);
          data.append('number_of_happy', this.formData.number_of_happy);
          // Tambahkan
          this.formData.journeytitle.forEach((title, index) => {
            data.append(`journey_title[${index}]`, title);
          });
          this.formData.journeynumber.forEach((number, index) => {
            data.append(`journey_number[${index}]`, number);
          });
          this.formData.journeyicon.forEach((icon, index) => {
            data.append(`journey_icon[${index}]`, icon);
          });
          
          this.formData.banner.forEach((file) => {
             data.append('banner', file);
           }); 
           this.formData.banner_title.forEach((desc, index) => {
             data.append(`banner_title[${index}]`, desc);
           });
        }
        console.log(this.formData);

        config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: 'https://api-profile.productscala.online/admin/industry',
        headers: { 
          'Authorization': 'Bearer '+ access_token // Replace with the actual token
        },
        data: data,
        };
      }else if (this.method == 'edit') {
        data.append('title', this.formData.title);
        data.append('description_content_pages', this.formData.desciptioncontent);
        data.append('icon', this.formData.icon);
        if (this.formData.cover) {
          data.append('cover', this.formData.cover);
        }

        config = {
        method: 'put',
        maxBodyLength: Infinity,
        url: 'https://api-profile.productscala.online/admin/industry/' + this.formData.id,
        headers: { 
          'Authorization': 'Bearer '+ access_token // Replace with the actual token
        },
        data: data,
        }
      }else{
        if (this.optionselect == 1 || this.optionselect == 2) {
          data.append('description', this.formData.desciption);
          data.append('file', this.formData.files);    
        }else if (this.optionselect == 3) {
          data.append('content', this.formData.content);  
        }else if (this.optionselect == 4) {
          data.append('content', this.formData.content);
          data.append('logo', this.formData.logo);
          data.append('location', this.formData.location);
          data.append('industry', this.formData.industry);
          data.append('use_case', this.formData.use_case);
          data.append('size_of_company', this.formData.size_of_company);
          data.append('number_of_happy', this.formData.number_of_happy);
          this.formData.banner.forEach((file) => {
            data.append('banner', file);
          }); 
          this.formData.banner_title.forEach((desc, index) => {
            data.append(`banner_title[${index}]`, desc);
          });
        }

        config = {
        method: 'put',
        maxBodyLength: Infinity,
        url: 'https://api-profile.productscala.online/admin/industry_detail/' + this.optionselect + '/' + this.formData.id,
        headers: { 
          'Authorization': 'Bearer '+ access_token // Replace with the actual token
        },
        data: data,
        }
      }
      
      try {
        const response = await axios.request(config);
        if (response.data?.message == 'success') {
          this.fetchindustryList();
          if (this.method == 'add') { 
            this.$swal({
              title: "Success!",
              text: "Add data success",
              icon: "success"
            });
          this.alertstatus = '';
          }else{
            this.$swal({
              title: "Success!",
              text: "Edit data success",
              icon: "success"
            });
          }
          
          setTimeout(function(){
            window.location.reload(1);
          }, 1500);
          this.closeModal(); // Close modal after successful submission
        }else{
          this.alertstatus = 'danger';
          this.alerttext = 'Error add data'
        }
        console.log(response.data);
      } catch (error) {
        var err = error.response.data.message
        this.alertstatus = 'danger';
        this.alerttext = err;
        this.closeModal(); // Close modal after successful submission
        console.error("Error fetching data:", error);
      }
    },

    async hapus(id) {
      let access_token = localStorage.getItem('access_token');
      const result = await this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!"
      });

      if (result.isConfirmed) {
        const config = {
          method: 'delete', // Ganti ke delete jika API menggunakan method ini
          maxBodyLength: Infinity,
          url: 'https://api-profile.productscala.online/admin/industry/' + id,
          headers: {
            'Authorization': 'Bearer ' + access_token // Replace with the actual token
          }
        };

        try {
          const response = await axios.request(config);
          if (response.data?.message == 'success') {
            await this.fetchindustryList(); // Refresh banner list after deletion
            this.$swal({
              title: "Deleted!",
              text: "Your data has been deleted.",
              icon: "success"
            });
          } else {
            this.$swal({
              title: "Error!",
              text: "There was an issue deleting the data.",
              icon: "error"
            });
          }
        } catch (error) {
          console.error(error);
          this.$swal({
            title: "Error!",
            text: "Failed to delete the data.",
            icon: "error"
          });
        }
      }
    },

    edit (item) {
      this.formData = {
        pages: item?.pages,
        title: item?.title,
        icon: item.icon,
        desciptioncontent: item.description_content_pages,
        id: item.id, 
        optioncontent: item.option_content_page 
      };
      this.imgreview = item.cover;
      this.showModal = true;
      this.method = 'edit';
    },
    editdetail (item, option) {
      console.log(item);
      
      this.optionselect = option
      this.formData = {
        id: item?.id,
        desciption: item?.description,
        files: [],
        content: item?.content,
        logo: item?.logo,
        location: item?.location,
        industry: item?.industry,
        use_case: item?.use_case,
        size_of_company: item?.size_of_company,
        number_of_happy: item?.number_of_happy
      };
      this.imgreview = item.file;
      if (option == 4) {
        this.journeyDataold = item?.journey_data; // Simpan data journey terpisah       
        this.jmljourneyDataold = this.journeyDataold.length         
        this.journeyData = item?.journey_data; // Simpan data journey terpisah     
        this.formData.banner = item?.banner_list.map(item => item.banner);
        this.formData.banner_title = item?.banner_list.map(item => item.title);  
      }
      this.showModal = true;
      this.method = 'editdetail';
    },
    addDetailiconEdit() {
      this.journeyData.push({
        id: null,
        title: "",
        number: "",
        icon: "",
      });
    },
    async removeDetailIcon(id, index) {
      if (id) {
        let access_token = localStorage.getItem('access_token');
        const result = await this.$swal({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes, delete it!"
        });

        if (result.isConfirmed) {
          const config = {
            method: 'delete', // Ganti ke delete jika API menggunakan method ini
            maxBodyLength: Infinity,
            url: 'https://api-profile.productscala.online/admin/industry_journey/' + id,
            headers: {
              'Authorization': 'Bearer ' + access_token // Replace with the actual token
            }
          };

          try {
            const response = await axios.request(config);
            if (response.data?.message == 'success') {
              await this.fetchindustryList(); // Refresh banner list after deletion
              this.journeyData.splice(index, 1);
              this.$swal({
                title: "Deleted!",
                text: "Your data has been deleted.",
                icon: "success"
              });
              this.closeModal();
            } else {
              this.$swal({
                title: "Error!",
                text: "There was an issue deleting the data.",
                icon: "error"
              });
            }
          } catch (error) {
            var err = error.response.data.message
            this.$swal({
              title: "Error!",
              text: err,
              icon: "error"
            });
          }
        }
      }else {
        this.journeyData.splice(index, 1);
      }
    },
    async updateDetailIcon(id, index) {
      let access_token = localStorage.getItem('access_token');
      const item = this.journeyData[index]; 
      
      const formattedData = {
        'industry_detail_data_id': this.formData.id,
        'journey_title': item?.title,
        'journey_icon': item?.icon,
        'journey_number': item?.number
      }
      
      const config = {
        method: 'put',
        maxBodyLength: Infinity,
        url: 'https://api-profile.productscala.online/admin/industry_journey/' + item.id,
        headers: { 
          'Authorization': 'Bearer '+ access_token // Replace with the actual token
        },
        data: formattedData,
      }
      try {
            const response = await axios.request(config);
            if (response.data?.message == 'success') {
              await this.fetchindustryList(); // Refresh banner list after deletion
              this.$swal({
                title: "Update",
                text: "Your data has been Update.",
                icon: "success"
              });
              this.closeModal();
            } else {
              this.$swal({
                title: "Error!",
                text: "There was an issue deleting the data.",
                icon: "error"
              });
            }
          } catch (error) {
            var err = error.response.data.message
            this.$swal({
              title: "Error!",
              text: err,
              icon: "error"
            });
          }
      
    },
    async addicon(item){
      let access_token = localStorage.getItem('access_token');

      const formattedData = [
        {
          "journey_title": item.title,
          "journey_icon":item.icon,
          "journey_number":item.number
        }
      ]
      console.log(formattedData);

      const config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: 'https://api-profile.productscala.online/admin/industry_journey/' + this.formData.id,
        headers: { 
          'Authorization': 'Bearer '+ access_token // Replace with the actual token
        },
        data: formattedData,
      }
      try {
            const response = await axios.request(config);
            if (response.data?.message == 'success') {
              await this.fetchindustryList(); // Refresh banner list after deletion
              this.$swal({
                title: "Saved",
                text: "Your data has been Saved.",
                icon: "success"
              });
              this.closeModal();
            } else {
              this.$swal({
                title: "Error!",
                text: "There was an issue deleting the data.",
                icon: "error"
              });
            }
          } catch (error) {
            var err = error.response.data.message
            this.$swal({
              title: "Error!",
              text: err,
              icon: "error"
            });
          }
    },
    validateInput(event) {
      const key = event.key;
      // Allow only digits and backspace
      if (!/[0-9\b]/.test(key)) {
        event.preventDefault();
      }
      
    },
  },
};
</script>
<style>
/* Optional: Ensure modal is shown properly */
.modal.show {
  display: block; /* Override display to block */
}
.modal-backdrop {
  opacity: 50%;
}
.large-editor {
  height: 300px !important; /* Atur tinggi editor */
  width: 100%; /* Lebar menyesuaikan kontainer */
}

.large-editor .ql-container {
  min-height: 400px; /* Atur area konten */
}

.large-editor .ql-editor {
  font-size: 16px; /* Ukuran teks */
  padding: 16px; /* Ruang di dalam editor */
}
.custom-width-modal {
  max-width: 100% !important;
  margin-left: 17.125rem !important;
}

</style>